import { render, staticRenderFns } from "./User-edit.vue?vue&type=template&id=65cc067a&"
import script from "./User-edit.vue?vue&type=script&lang=js&"
export * from "./User-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports